
//#region Imports
import React, { useEffect, useLayoutEffect, useState, useImperativeHandle, forwardRef } from 'react';
import { useLocation } from 'react-router-dom';
//MUI
import CloseIcon from '@mui/icons-material/Close';
import DescriptionIcon from '@mui/icons-material/Description';
import { Backdrop, Box, Button, Grid, MenuItem, Select, Typography, useMediaQuery } from '@mui/material';
import TextField from '../../../components/SanitizedTextField/SanitizedTextField';
import AppLoader from '../../../components/AppLoader/AppLoader';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import warning from '../../../images/warning.png';
import { tableStyleOverDue } from '../../../style/common';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import InfoIcon from '@mui/icons-material/Info';

//components
//scss
import "../../../style/common.scss";
import "./DueDateExtensionWorkflowDialog.scss";
import {
    WORKFLOW_MOBILE_MEDIA,
    workflowDialogClassName,
    workflowDialogShellProps,
} from '../../../utils/workflowDialogShell';
//Yup
import * as Yup from "yup";
//formik

import { useFormik } from 'formik';
//urls
import { cfpBaseUrl } from '../../../network/urls';
// use scan detection
import useScanDetection from 'use-scan-detection';
import CheckPermissions from '../../../authorization/authorization';
//Services
import StepProgressBar from '../../../components/StepProgressBar/StepProgressBar';
import ProcessingSummaryTableBilling from '../../../components/processingSummaryTable/processingSummaryTableBilling';
import { tableStyle } from '../../../style/common';

import { useDispatch, useSelector } from 'react-redux';
import BasicTable from '../../../components/basicTable/basicTable';
import ServiceDashboardTables from '../../../components/ServiceDashboardTables/ServiceDashboardTables';
import Error from '../../../components/error/error';
import { SearchIndividualApplication } from '../../../network/APIs/APIs';
import { addBusinessDays, calculateRemainingBusinessDays, daysBetweenDatesExcludingWeekendsAndHolidays, downloadBill, formatBillMonth, getConsumerDetails, isSameBillMonth, numberFormatting, subdivisionName } from '../../../services/Functions';

import {
    fetchPaginatedDueDateExtensionNormal,
    filterDateFrom as filterDateFromNormal,
    filterDateTo as filterDateToNormal,
    filterObjectionStatus as filterObjectionStatusNormal,
    filterProgressId as filterProgressIdNormal,
    firstPage as firstPageNormal,
    lastPage as lastPageNormal,
    nextPage as nextPageNormal,
    previousPage as previousPageNormal,
    resetDateFilter as resetDateFilterNormal,
    resetObjectionStatusFilter as resetObjectionStatusFilterNormal,
    resetProgressIdFilter as resetProgressIdFilterNormal,
    resetState as resetStateDueDateNormal,
} from '../../../features/billingAndCollection/dueDateExtensionNormalSlice';

import {
    fetchPaginatedDueDateExtensionOverdue,
    filterDateFrom as filterDateFromOverdue,
    filterDateTo as filterDateToOverdue,
    filterObjectionStatus as filterObjectionStatusOverdue,
    filterProgressId as filterProgressIdOverdue,
    firstPage as firstPageOverdue,
    lastPage as lastPageOverdue,
    nextPage as nextPageOverdue,
    previousPage as previousPageOverdue,
    resetDateFilter as resetDateFilterOverdue,
    resetObjectionStatusFilter as resetObjectionStatusFilterOverdue,
    resetProgressIdFilter as resetProgressIdFilterOverdue,
    resetState as resetStateDueDateOverdue,
} from '../../../features/billingAndCollection/dueDateExtensionOverdueSlice';
import { getInitialAdminOfficeCode, isBillingTableFetchEnabled } from '../../../utils/adminCompany';
import { DISCO_COMPANIES } from '../../../constants/discoCompanies';
import RightArrow from '../../../images/right-arrow.png';
//#endregion

const toProgressId = (val) => Number(val);

// Step bar has 2 steps: Submitted (0) and Action Taken (1).
// When progress is 1 (approved) or -1 (rejected), both steps show as completed (dark blue).
const getDueDateExtensionStepIndex = (row) =>
    toProgressId(row?.applicationProgressId) === 0 ? 0 : 2;

const getDueDateExtensionStepObjection = () => 0;

const DueDateExtensionTable = forwardRef((props, ref) => {

    //#region initial values
    const initialValues = {
        iv_approved_no_of_days: null,
        iv_approved_due_date: null
    }

    //#endregion

    //#region get item local storage 
    const { token, code: officeCode, hierarchy: officeHierarchy, userId, permissions, selectedAdminCompanyCode } = useSelector((state) => state.auth);
    const isWorkflowMobile = useMediaQuery(WORKFLOW_MOBILE_MEDIA);
    const [selectedOfficeCode, setSelectedOfficeCode] = useState(
        getInitialAdminOfficeCode(officeCode, selectedAdminCompanyCode),
    );
    const canFetchBillingData = isBillingTableFetchEnabled(officeCode);
    const apiOfficeCode = String(officeCode) === "10"
        ? selectedOfficeCode
        : (selectedOfficeCode || officeCode);

    useEffect(() => {
        if (String(officeCode) === "10" && selectedAdminCompanyCode) {
            setSelectedOfficeCode(String(selectedAdminCompanyCode));
        }
    }, [officeCode, selectedAdminCompanyCode]);
    const subDivisions = JSON.parse(window.localStorage.getItem('subDivisions'));
    //#endregion

    //#region states

    const [error, setError] = useState()
    const [ddeApplicationsNormal, setDdeApplicationsNormal] = useState([]);
    const [ddeApplicationsNormalToDataGrid, setDdeApplicationsNormalToDataGrid] = useState([]);
    const [dayName, setDayName] = useState('-');
    const [tableMonthDate, setTableMonthDate] = useState('');
    const [dBillMonthDate, setDBillMonthDate] = useState('');
    const [ddeApplicationsOverdue, setDdeApplicationsOverdue] = useState([]);
    const [ddeApplicationsOverdueToDataGrid, setDdeApplicationsOverdueToDataGrid] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [dialogRowData, setDialogRowData] = React.useState({});
    const [applicationId, setapllicationid] = React.useState('')
    const [eFileData, setEFileData] = useState([]);
    const [viewBackdrop, setViewBackdrop] = useState(false);
    const [applicationSubittedPopUp, setApplicationSubmittedPopUp] = useState(false);
    const [availableDays, setAvailableDays] = useState([]);
    const [resultPopup, setResultPopup] = useState(null)
    const [openCancelModal, setOpenCancelModal] = useState(false);
    const tableColumnsProcessingSummary = [
        {
            header: 'Step',
            accessorKey: 'stepName',
        },
        {
            header: 'Processed By',
            accessorKey: 'processedBy',
        },
        {
            header: 'Date',
            accessorKey: 'date',
        },
        {
            header: 'Remarks',
            accessorKey: 'remarks',
        },
    ]

    const [tableDataProcessingSummary, setTableDataProcessingSummary] = useState([
        {
            stepName: 'Application Submission',
            processedBy: 'Akram',
            date: '24-Dec-2023',
            time: '02:23:19 AM',
            remarks: '-',
        },
        {
            stepName: 'Application Submission',
            processedBy: 'Akram',
            date: '24-Dec-2023',
            time: '02:23:19 AM',
            remarks: '-',
        },
        {
            stepName: 'Application Submission',
            processedBy: 'Akram',
            date: '24-Dec-2023',
            time: '02:23:19 AM',
            remarks: '-',
        },
    ])
    const dispatch = useDispatch();

    useEffect(() => {
        if (!canFetchBillingData) {
            setDdeApplicationsNormal([]);
            setDdeApplicationsNormalToDataGrid([]);
            setDdeApplicationsOverdue([]);
            setDdeApplicationsOverdueToDataGrid([]);
            setViewBackdrop(false);
            dispatch(resetStateDueDateNormal());
            dispatch(resetStateDueDateOverdue());
        }
    }, [canFetchBillingData, dispatch]);

    let DDStatusBarArray = [
        {
            title1: 'APPLICATION',
            title2: 'SUBMITTED',
        },
        {
            title1: 'ACTION',
            title2: 'TAKEN',
        },

    ]

    const [foundInDDE, setFoundInDDE] = useState();
    const { state } = useLocation();
    const { foundId } = state ? state : '';
    const [isReleventToUser, setIsRelevantToUser] = useState(false)


    //#endregion

    //#endregion

    const { currentPage: currentPageNormal, data: dataNormal, pageSize: pageSizeNormal, totalPages: totalPagesNormal, totalRecords: totalRecordsNormal, dateFrom: dateFromNormal, dateTo: dateToNormal, applicationProgressId: applicationProgressIdNormal, objectionStatus: objectionStatusNormal, error: errorNormal, isLoading: isLoad } = useSelector((state) => state.dueDateExtensionNormalPaginated);
    const { currentPage: currentPageOverdue, data: dataOverdue, pageSize: pageSizeOverdue, totalPages: totalPagesOverdue, totalRecords: totalRecordsOverdue, dateFrom: dateFromOverdue, dateTo: dateToOverdue, applicationProgressId: applicationProgressIdOverdue, objectionStatus: objectionStatusOverdue, error: errorOverdue, isLoading: isLoadd } = useSelector((state) => state.dueDateExtensionOverduePaginated);

    const handleNextPage = () => {
        dispatch(nextPageNormal());
    };

    const handleDateFromFilter = (value) => {
        if (value) {
            setViewBackdrop(true)
            dispatch(filterDateFromNormal(value))
        }
    }

    const handleDateToFilter = (value) => {
        if (value) {
            setViewBackdrop(true)
            dispatch(filterDateToNormal(value))
        }
    }

    const handleResetDateFilter = () => {
        dispatch(resetDateFilterNormal())
    }

    const handleProgressIdFilter = (value) => {
        if (value || value === 0) {
            setViewBackdrop(true)
            dispatch(filterProgressIdNormal(value))
        }
    }

    const handleResetProgressIdFilter = () => {
        dispatch(resetProgressIdFilterNormal())
    }

    const handleObjectionStatusFilter = (value) => {
        if (value || value === 0) {
            setViewBackdrop(true)
            dispatch(filterObjectionStatusNormal(value))
        }
    }

    const handleResetObjectionStatusFilter = () => {
        dispatch(resetObjectionStatusFilterNormal())
    }

    const handlePreviousPage = () => {
        dispatch(previousPageNormal());
    };

    const handleFirstPage = () => {
        dispatch(firstPageNormal());
    };

    const handleLastPage = (page) => {
      dispatch(lastPageNormal(typeof page === 'number' ? page : totalPagesNormal));
    };

    useEffect(() => {
        if ((props.showTable && currentPath == "/due-date-extension-table") && token && canFetchBillingData) {
            dispatch(fetchPaginatedDueDateExtensionNormal({ page: currentPageNormal, pageSize: pageSizeNormal, dateFrom: dateFromNormal, dateTo: dateToNormal, applicationProgressId: applicationProgressIdNormal, objectionStatus: objectionStatusNormal, officeCode: apiOfficeCode }));
        }
    }, [currentPageNormal, pageSizeNormal, dateFromNormal, dateToNormal, applicationProgressIdNormal, objectionStatusNormal, apiOfficeCode, canFetchBillingData]);

    useEffect(() => {
        if (!canFetchBillingData) return;
        if (dataNormal) {
            setDdeApplicationsNormal(dataNormal)
            setViewBackdrop(false)
        }
    }, [dataNormal, canFetchBillingData])

    const handleNextPageOverdue = () => {
        dispatch(nextPageOverdue());
    };

    const handleDateFromFilterOverdue = (value) => {
        if (value) {
            setViewBackdrop(true)
            dispatch(filterDateFromOverdue(value))
        }
    }

    const handleDateToFilterOverdue = (value) => {
        if (value) {
            setViewBackdrop(true)
            dispatch(filterDateToOverdue(value))
        }
    }

    const handleResetDateFilterOverdue = () => {
        dispatch(resetDateFilterOverdue())
    }

    const handleProgressIdFilterOverdue = (value) => {
        if (value || value === 0) {
            setViewBackdrop(true)
            dispatch(filterProgressIdOverdue(value))
        }
    }

    const handleResetProgressIdFilterOverdue = () => {
        dispatch(resetProgressIdFilterOverdue())
    }

    const handleObjectionStatusFilterOverdue = (value) => {
        if (value || value === 0) {
            setViewBackdrop(true)
            dispatch(filterObjectionStatusOverdue(value))
        }
    }

    const handleResetObjectionStatusFilterOverdue = () => {
        dispatch(resetObjectionStatusFilterOverdue())
    }

    const handlePreviousPageOverdue = () => {
        dispatch(previousPageOverdue());
    };

    const handleFirstPageOverdue = () => {
        dispatch(firstPageOverdue());
    };

    const handleLastPageOverdue = (page) => {
      dispatch(lastPageOverdue(typeof page === 'number' ? page : totalPagesOverdue));
    };

    useEffect(() => {
        if ((props.showTable && currentPath == "/due-date-extension-table") && token && canFetchBillingData) {
            dispatch(fetchPaginatedDueDateExtensionOverdue({ page: currentPageOverdue, pageSize: pageSizeOverdue, dateFrom: dateFromOverdue, dateTo: dateToOverdue, applicationProgressId: applicationProgressIdOverdue, objectionStatus: objectionStatusOverdue, officeCode: apiOfficeCode }));
        }
    }, [currentPageOverdue, pageSizeOverdue, dateFromOverdue, dateToOverdue, applicationProgressIdOverdue, objectionStatusOverdue, apiOfficeCode, canFetchBillingData]);

    useEffect(() => {
        if (!canFetchBillingData) return;
        if (dataOverdue) {
            setDdeApplicationsOverdue(dataOverdue)
            setViewBackdrop(false)
        }
    }, [dataOverdue, canFetchBillingData])

    //#region api function
    const duedateextensionapi = async (x, values) => {
        setViewBackdrop(true)
        const formattedDate = values.split("-").reverse().join("-");
        var formdata = new FormData();
        formdata.append("applicationId", applicationId);
        formdata.append("lastModifiedBy", userId);
        formdata.append("applicationProgressId", x);
        formdata.append("approvedExtendedDueDate", formattedDate);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);;
        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
        };
        await fetch(cfpBaseUrl + "dateExtention/dueDateAppProgId", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === '200') {
                    setViewBackdrop(false)
                    handleClose()
                } else if (result.message.startsWith('Since the month end process')) {
                    setError(result.message)
                    setViewBackdrop(false)
                } else if (result.status === '400') {
                    setError(result.message)
                    setViewBackdrop(false)
                }
            })
            .catch(() => {});
    }

    const objectionpop = async () => {
        await duedateextensionapi(-1, dueDateApprovalFormik.values.iv_approved_due_date)
    }

    //#endregion

    //#region functions

    const errorCloses = () => {
        setError('')
    }

    useScanDetection({
        onComplete: async (code) => {
            if (code) {
                code = code.replace(/Shift/g, '');
                const regex = /^[A-Z]{2}-\d{14,15}$/;
                if (regex.test(code)) {
                    await handleRowClick(code);
                }
            }
        },
        minLength: 4, // EAN13
    });

    const handleClose = () => {
        setIsRelevantToUser(false);
        setOpen(false);
        setDialogRowData({});
        setapllicationid('');
        setApplicationSubmittedPopUp(false);
        setAvailableDays([]);
        setResultPopup(null);
        setOpenCancelModal(false);
        setTableDataProcessingSummary([]);
        setDayName('-');
        setTableMonthDate('');
        setDBillMonthDate('');
        setError('');
        setViewBackdrop(false);
        setEFileData([]);
        setFoundInDDE(undefined);
        dueDateApprovalFormik.resetForm();
        remarksFormik.resetForm({ values: { iv_remarks: '' } });
        dispatch(fetchPaginatedDueDateExtensionNormal({ page: currentPageNormal, pageSize: pageSizeNormal, dateFrom: dateFromNormal, dateTo: dateToNormal, applicationProgressId: applicationProgressIdNormal, objectionStatus: objectionStatusNormal, officeCode: apiOfficeCode }));
        dispatch(fetchPaginatedDueDateExtensionOverdue({ page: currentPageOverdue, pageSize: pageSizeOverdue, dateFrom: dateFromOverdue, dateTo: dateToOverdue, applicationProgressId: applicationProgressIdOverdue, objectionStatus: objectionStatusOverdue, officeCode: apiOfficeCode }));
    };

    const getClassName = (x) => {
        if (x === "Pending") {
            return 'pending-button';
        }
        else if (x === "In Process") {
            return 'inprocess-button';
        }
        else if (x === "Approved") {
            return 'approved-button';
        }
        else if (x === "Objection") {
            return 'objection-button';
        }
        else if (x === "Rejected") {
            return 'rejected-button';
        }
    }

    const filterNCApp = async (applicationId) => {
        let myArray = ddeApplicationsNormal
        let totalArray = myArray.concat(ddeApplicationsOverdue)
        let itemFound = totalArray.find(item => item.applicationId === applicationId)

        if (itemFound) {
            setIsRelevantToUser(true)
        }
        else if (itemFound === undefined) {
            itemFound = await SearchIndividualApplication(token, applicationId, '7')
            setIsRelevantToUser(itemFound.isReleventToUser)
        }
        return itemFound;
    }

    const convertDate = (dateString) => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const date = new Date(dateString);
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }

    const convertDatewithTime = (dateString) => {
        if (!dateString) return '-';
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const date = new Date(dateString);
        if (Number.isNaN(date.getTime())) return '-';
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        const padZero = (value) => (value < 10 ? `0${value}` : value);
        const hour = padZero(date.getHours());
        const minute = padZero(date.getMinutes());
        const second = padZero(date.getSeconds());
        return `${day}-${month}-${year} ${hour}:${minute}:${second}`;
    }

    const apiToDataGridConversionNormal = () => {

        const tempArray = []
        if (ddeApplicationsNormal) {
            ddeApplicationsNormal.forEach((item) => {
                let dataGridObject = {}
                if (item.applicationId) {
                    if (item.objectionStatus === 0) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDate(item.creationDate),
                            //"connectionType": item.connectionType,
                            "referenceNo": item.refNo,
                            "name": item.name,
                            "dueDate": convertDate(item.dueDate),
                            "extendedDueDate": convertDate(item.appliedExtentionOfDueDate),
                            "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                            "applicationProgressId": progFunc(item.applicationProgressId),
                            "releventApplicationFlage": item.releventApplicationFlage,
                        }
                    }
                    else if (item.objectionStatus === 1) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDate(item.creationDate),
                            //"connectionType": item.connectionType,
                            "referenceNo": item.refNo,
                            "name": item.name,
                            "dueDate": item.dueDate,
                            "extendedDueDate": item.appliedExtentionOfDueDate,
                            "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                            "applicationProgressId": item.remarks,
                            "releventApplicationFlage": item.releventApplicationFlage,
                        }
                    }
                    tempArray.push(dataGridObject)
                }
            })
        }
        else {
            const dataGridObject = {
                "applicationId": ' ',
                "connectionType": '',
                // "appliedLoad": item.appliedLoad,
                // "duration": item.duration,
                "applicantName": ' ',
                "applicantCNIC": ' ',
                "applicationStatusId": statusFunc(' '),
            }
            tempArray.push(dataGridObject)
        }
        setDdeApplicationsNormalToDataGrid(tempArray);
    }

    const apiToDataGridConversionOverdue = () => {

        const tempArray = []
        if (ddeApplicationsOverdue) {
            ddeApplicationsOverdue.forEach((item) => {
                let dataGridObject = {}
                if (item.applicationId) {
                    if (item.objectionStatus === 0) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDate(item.creationDate),
                            //"connectionType": item.connectionType,
                            "referenceNo": item.refNo,
                            "name": item.name,
                            "dueDate": convertDate(item.dueDate),
                            "extendedDueDate": convertDate(item.appliedExtentionOfDueDate),
                            "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                            "applicationProgressId": progFunc(item.applicationProgressId),
                            "releventApplicationFlage": item.releventApplicationFlage,
                        }
                    }
                    else if (item.objectionStatus === 1) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDate(item.creationDate),
                            //"connectionType": item.connectionType,
                            "referenceNo": item.refNo,
                            "name": item.name,
                            "dueDate": item.dueDate,
                            "extendedDueDate": item.appliedExtentionOfDueDate,
                            "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                            "applicationProgressId": item.remarks,
                            "releventApplicationFlage": item.releventApplicationFlage,
                        }
                    }
                    tempArray.push(dataGridObject)
                }
            })
        }
        else {
            const dataGridObject = {
                "applicationId": ' ',
                "connectionType": '',
                // "appliedLoad": item.appliedLoad,
                // "duration": item.duration,
                "applicantName": ' ',
                "applicantCNIC": ' ',
                "applicationStatusId": statusFunc(' '),
            }
            tempArray.push(dataGridObject)
        }
        setDdeApplicationsOverdueToDataGrid(tempArray);
    }

    const statusFunc = (x, objection) => {
        if (x === 0) {
            return 'In Process'
        }
        else if (x === 1) {
            return 'Approved'
        }
        else if (x === -1) {
            return 'Rejected'
        }
    }

    const progFunc = (x) => {
        if (x === 0) {
            return 'Documents Uploading'
        }
        else if (x === 1) {
            return 'Documents Verification'
        }
        else if (x === 2) {
            return 'Arrears Verification'
        }
        else if (x === 3) {
            return 'Field Verification'
        }
        else if (x === 4) {
            return 'Demand Note Issued'
        }
        else if (x === 5) {
            return 'DN Payment Verification'
        }
        else if (x === 6) {
            return 'Meter Installation'
        }
        else if (x === 7) {
            return 'Ready for Billing'
        }
    }
    const formatToDDMMYYYY = (dateString) => {
        if (!dateString) return "-";

        const [year, month, day] = dateString.split("-");
        return `${day}-${month}-${year}`;
    };
    const handleRowClick = async (applicationId, event) => {
        const item = await filterNCApp(applicationId);
        if (item) {
            setViewBackdrop(true);
            try {
                setDialogRowData(item);
                setTableMonthDate(item.billMonth || '');
                setDBillMonthDate('');

                const refForBill = item.refNo || item.customerId;
                if (refForBill) {
                    try {
                        const consumerResponse = await getConsumerDetails(token, refForBill);
                        const consumer = consumerResponse?.data?.[0];
                        if (consumer?.BILL_MONTH) {
                            setDBillMonthDate(consumer.BILL_MONTH);
                        }
                    } catch (e) { /* ignored */ }
                }

                let noOfDaysApplied = daysBetweenDatesExcludingWeekendsAndHolidays(new Date(item.dueDate), new Date(item.appliedExtentionOfDueDate));
                const remainingDays = calculateRemainingBusinessDays(item.dueDate);
                setAvailableDays(remainingDays);
                dueDateApprovalFormik.values.iv_approved_no_of_days = noOfDaysApplied
                dueDateApprovalFormik.values.iv_approved_due_date = formatToDDMMYYYY(item.appliedExtentionOfDueDate)

                let dataforTable = [];

                if (item.applicationProgressId === 0) {
                    dataforTable.push({
                        date: convertDatewithTime(item.creationDate),
                        processedBy: item.name,
                        stepName: "Application Submitted",
                        remarks: 'Application Submitted.'
                    });
                }
                else if (item.applicationProgressId === 1 || item.applicationProgressId === -1) {

                    dataforTable.push({
                        stepName: stepName(item.applicationProgressId),
                        processedBy: item.lastModifiedBy || 'N/A',
                        date: item.lastModificationDate ? convertDatewithTime(item.lastModificationDate) : 'N/A',
                        remarks: item.remarks || '-',
                    });

                    dataforTable.push({
                        date: convertDatewithTime(item.creationDate),
                        processedBy: item.name,
                        stepName: "Application Submitted",
                        remarks: 'Application Submitted.'
                    });

                }

                setTableDataProcessingSummary(dataforTable);

                setapllicationid(item.applicationId)
                setOpen(true);
            } finally {
                setViewBackdrop(false);
            }
        }
    };

    const openDetailsPopUp = async (stepName) => {
        let id = dialogRowData.applicationId

        if (stepName === "APPLICATION SUBMITTED" || stepName === "Application Submitted") {
            setApplicationSubmittedPopUp(true)
        }
    }

    const stepName = (x) => {
        if (x === 0) {
            return 'Application Submission'
        }
        else if (x === 1 || x === -1) {
            return 'Action Taken'
        }
    };

    //#endregion

    //#region formiks

    const dueDateApprovalFormik = useFormik({
        initialValues,
        validationSchema: Yup.object({
            // iv_approved_no_of_days: Yup.number().required('Enter number of days to extend due date.'),
            iv_approved_due_date: Yup.string().required('Extended due date is required.')
        }),
        onSubmit: async (values, { resetForm }) => {
            setViewBackdrop(true)
            try {

                const x = 1;

                const formattedDate = values.iv_approved_due_date.split("-").reverse().join("-");

                var formdata = new FormData();
                formdata.append("remarks", "Approved.");
                formdata.append("applicationId", applicationId);
                formdata.append("lastModifiedBy", userId);
                formdata.append("applicationProgressId", x);
                formdata.append("approvedExtendedDueDate", formattedDate);
                const myHeaders = new Headers();
                myHeaders.append("Authorization", token);;
                var requestOptions = {
                    method: 'POST',
                    body: formdata,
                    headers: myHeaders,
                    redirect: 'follow',
                };
                await fetch(cfpBaseUrl + "dateExtention/dueDateAppProgId", requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status === '200') {
                            setResultPopup('approve')
                        } else {
                            setError(result.message)
                        }
                    })
                    .catch(() => {});
            }
            catch (e) {
            }
            setViewBackdrop(false)
        }
    })

    //#endregion

    //#region useEffects

    useEffect(() => {
        if (!canFetchBillingData) return;
        if (ddeApplicationsNormal) {
            apiToDataGridConversionNormal()
        }
    }, [ddeApplicationsNormal, canFetchBillingData]);

    useEffect(() => {
        if (!canFetchBillingData) return;
        if (ddeApplicationsOverdue) {
            apiToDataGridConversionOverdue()
        }
    }, [ddeApplicationsOverdue, canFetchBillingData]);

    useEffect(() => {
        if (foundId && foundId !== '') {
            setFoundInDDE(foundId)
        }
    }, [foundId])

    useLayoutEffect(() => {
        if (foundInDDE) {
            handleRowClick(foundInDDE)
        }
    }, [foundInDDE])

    useEffect(() => {
        if (dueDateApprovalFormik.values.iv_approved_no_of_days) {
            let appliedDueDate = new Date(dialogRowData.dueDate);
            let futureDate = addBusinessDays(appliedDueDate, dueDateApprovalFormik.values.iv_approved_no_of_days);
            const year = futureDate.getFullYear();
            const month = ('0' + (futureDate.getMonth() + 1)).slice(-2);
            const day = ('0' + futureDate.getDate()).slice(-2);
            const formattedDate = `${day}-${month}-${year}`;
            dueDateApprovalFormik.values.iv_approved_due_date = formattedDate;
        }
    }, [dueDateApprovalFormik.values.iv_approved_no_of_days])
    const getDayName = (dateString) => {
        if (!dateString) return "-";

        let date;

        if (dateString.includes("-") && dateString.split("-")[0].length === 4) {
            const [year, month, day] = dateString.split("-");
            date = new Date(Number(year), Number(month) - 1, Number(day));
        } else if (dateString.includes("-")) {
            const [day, monthStr, year] = dateString.split("-");
            const month = new Date(Date.parse(monthStr + " 1, 2020")).getMonth();
            date = new Date(Number(year), month, Number(day));
        } else {
            return "-";
        }

        if (isNaN(date)) return "-";
        return date.toLocaleString("en-US", { weekday: "long" });
    };
    const formatDateToShortMonth = (dateString) => {
        if (!dateString) return "-";

        const [day, month, year] = dateString.split("-");
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        const monthIndex = parseInt(month, 10) - 1;
        if (monthIndex < 0 || monthIndex > 11) return "-";

        return `${day}-${months[monthIndex]}-${year}`;
    };


    //#endregion

    const tblColumns = [
        { field: "applicationId", headerName: 'Application No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "creationDate", type: 'dateTime', headerName: 'Submission Date', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "referenceNo", headerName: 'Reference No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "name", headerName: 'Applicant Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "dueDate", type: 'dateTime', headerName: 'Due Date', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "extendedDueDate", type: 'dateTime', headerName: 'Requested Due Date', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        {
            field: "applicationStatusId",
            headerStyle: tableStyle.headerStyle,
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: tableStyle.rowCellStyle,
            headerName: "Status",
            align: 'center',
            sortable: false,
            filterable: true,
            type: 'singleSelect',
            valueOptions: ['In Process', 'Approved', 'Rejected'],
            renderCell: (params) => {
                let btnText = (params.applicationStatusId)
                return <div className={getClassName(btnText)}>{btnText}</div>
            }
        },
    ]

    const tblColumnsOverDue = [
        { field: "applicationId", headerName: 'Application No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "creationDate", type: 'dateTime', headerName: 'Submission Date', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "referenceNo", headerName: 'Reference No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "name", headerName: 'Applicant Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "dueDate", type: 'dateTime', headerName: 'Due Date', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "extendedDueDate", type: 'dateTime', headerName: 'Requested Due Date', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        {
            field: "applicationStatusId",
            headerStyle: tableStyleOverDue.headerStyle,
            headerCellStyle: tableStyleOverDue.headerCellStyle,
            rowCellStyle: tableStyleOverDue.rowCellStyle,
            headerName: "Status",
            align: 'center',
            sortable: false,
            filterable: true,
            type: 'singleSelect',
            valueOptions: ['In Process', 'Approved', 'Rejected'],
            renderCell: (params) => {
                let btnText = (params.applicationStatusId)
                return <div className={getClassName(btnText)}>{btnText}</div>
            }
        },
    ]

    useImperativeHandle(ref, () => ({
        handleRowClick
    }));

    const location = useLocation()
    const currentPath = location.pathname;

    const ranges = [
        { max: 25000, perm: '1 - 25,000' },
        { max: 50000, perm: '25,001 - 50,000' },
        { max: 100000, perm: '50,001 - 100,000' },
        { max: 200000, perm: '100,001 - 200,000' },
        { max: 300000, perm: '200,001 - 300,000' },
        { max: 500000, perm: '300,001 - 500,000' },
        { max: 1000000, perm: '500,001 - 1,000,000' },
        { max: 20000000, perm: '1,000,001 - 20,000,000' },
        { max: Infinity, perm: '20,000,001 - MAX' },
    ];

    const canApprove = (billAmount) => {
        let maxLimit = 0;

        for (let i = 0; i < ranges.length; i++) {
            const { max, perm } = ranges[i];

            const hasPermission = CheckPermissions(
                permissions,
                'Billing and Collection',
                'Due Date Extension',
                'Workflow Permissions',
                perm
            );

            if (hasPermission) {
                maxLimit = max;
            } else {
                break;
            }
        }

        return billAmount <= maxLimit;
    };

    const formatMonthYear = (dateString) => {
        if (!dateString) return '-';
        try {
            const raw = String(dateString).trim();
            if (!raw || raw === 'null' || raw === 'undefined') return '-';
            const formatted = formatBillMonth(raw);
            if (!formatted || formatted.includes('undefined') || formatted.includes('NaN')) {
                const match = raw.match(/^(\d{4})-(\d{2})/);
                if (match) {
                    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                    const monthIdx = parseInt(match[2], 10) - 1;
                    if (monthIdx >= 0 && monthIdx < 12) {
                        return `${months[monthIdx]}-${match[1]}`;
                    }
                }
                return '-';
            }
            return formatted;
        } catch {
            return '-';
        }
    };

    const isExtensionDateExpired = (dateString) => {
        if (!dateString) return false;

        const appliedDate = new Date(dateString);
        const today = new Date();


        appliedDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        return appliedDate < today;
    };

    const handleOpen = () => {
        setOpenCancelModal(true);
    };

    const handleCloseRemarks = () => {
        setOpenCancelModal(false);
        remarksFormik.resetForm({
            values: { iv_remarks: "" },
        });
    };

    const remarksFormik = useFormik({
        initialValues: {
            iv_remarks: "",
            // Add iv_approved_due_date if it’s part of the form
            // iv_approved_due_date: "",
        },
        validationSchema: Yup.object({
            iv_remarks: Yup.string()
                .min(10, "Remarks should be at least 10 characters.")
                .max(100, "Remarks should be less than 100 characters.")
                .required("Enter remarks."),
            // Add validation for iv_approved_due_date if needed
            // iv_approved_due_date: Yup.string().required("Date is required."),
        }),
        onSubmit: async (values) => {
            const x = -1;
            const formattedDate = dialogRowData.appliedExtentionOfDueDate
            setViewBackdrop(true);
            try {
                const formdata = new FormData();
                formdata.append("remarks", values.iv_remarks);
                formdata.append("applicationId", applicationId);
                formdata.append("lastModifiedBy", userId);
                formdata.append("applicationProgressId", x);
                formdata.append("approvedExtendedDueDate", formattedDate);
                const myHeaders = new Headers();
                myHeaders.append("Authorization", token);
                const requestOptions = {
                    method: 'POST',
                    body: formdata,
                    headers: myHeaders,
                    redirect: 'follow',
                };
                await fetch(cfpBaseUrl + "dateExtention/dueDateAppProgId", requestOptions)
                    .then(response => response.json())
                    .then(result => {
                        if (result.status === '200') {
                            setOpenCancelModal(false);
                            remarksFormik.resetForm({ values: { iv_remarks: "" } });
                            setResultPopup('reject');
                        } else if (result.message?.startsWith('Since the month end process')) {
                            setError(result.message);
                        } else {
                            setError('Failed to submit the application.');
                        }
                    })
                    .catch(() => {});
            } catch (e) {
            }
            setViewBackdrop(false);

        },
    });

    const handleCloseResultPopup = () => {
        setResultPopup(null);
        handleClose();
    };

    const ddeResultDialogConfig = {
        approve: {
            Icon: CheckCircleIcon,
            iconClassName: 'dde-result-dialog__icon dde-result-dialog__icon--approve',
            title: 'Request Approved',
            message: 'Due Date Extension request is Approved successfully.',
            showBill: true,
        },
        reject: {
            Icon: HighlightOffIcon,
            iconClassName: 'dde-result-dialog__icon dde-result-dialog__icon--reject',
            title: 'Request Rejected',
            message: 'Due Date Extension request is Rejected successfully.',
            showBill: false,
        },
    };

    const activeResultDialog = resultPopup ? ddeResultDialogConfig[resultPopup] : null;

    return (
        <>
            <ServiceDashboardTables
                enabled={props.showTable && currentPath === "/due-date-extension-table"}
                comfortableRows
                isLoadingNormal={canFetchBillingData && isLoad}
                isLoadingOverdue={canFetchBillingData && isLoadd}
                normalTitle={`Due Date Extensions ( ${canFetchBillingData && numberFormatting(totalRecordsNormal) ? numberFormatting(totalRecordsNormal) : "-"} )`}
                overdueCount={canFetchBillingData && numberFormatting(totalRecordsOverdue) ? numberFormatting(totalRecordsOverdue) : "-"}
                normalColumns={tblColumns}
                overdueColumns={tblColumnsOverDue}
                normalData={canFetchBillingData ? ddeApplicationsNormalToDataGrid : []}
                overdueData={canFetchBillingData ? ddeApplicationsOverdueToDataGrid : []}
                onRowClick={handleRowClick}
                mobileFields={["applicationId", "name", "applicationStatusId"]}
                showCompanyFilter={officeCode == 10}
                companies={DISCO_COMPANIES}
                selectedOfficeCode={selectedOfficeCode}
                onOfficeCodeChange={setSelectedOfficeCode}
                normalTableProps={{
                    firstPage: handleFirstPage,
                    lastPage: handleLastPage,
                    totalPages: totalPagesNormal,
                    totalRecords: totalRecordsNormal,
                    currentPage: currentPageNormal,
                    handleFilterDateFrom: handleDateFromFilter,
                    handleFilterDateTo: handleDateToFilter,
                    resetDateFilter: handleResetDateFilter,
                    handleFilterProgressId: handleProgressIdFilter,
                    handleFilterObjectionStatus: handleObjectionStatusFilter,
                    resetProgressIdFilter: handleResetProgressIdFilter,
                    resetObjectionStatusFilter: handleResetObjectionStatusFilter,
                    nextPage: handleNextPage,
                    previousPage: handlePreviousPage,
                }}
                overdueTableProps={{
                    firstPage: handleFirstPageOverdue,
                    nextPage: handleNextPageOverdue,
                    previousPage: handlePreviousPageOverdue,
                    lastPage: handleLastPageOverdue,
                    handleFilterDateFrom: handleDateFromFilterOverdue,
                    handleFilterDateTo: handleDateToFilterOverdue,
                    resetDateFilter: handleResetDateFilterOverdue,
                    resetProgressIdFilter: handleResetProgressIdFilterOverdue,
                    resetObjectionStatusFilter: handleResetObjectionStatusFilterOverdue,
                    handleFilterProgressId: handleProgressIdFilterOverdue,
                    handleFilterObjectionStatus: handleObjectionStatusFilterOverdue,
                    totalPages: totalPagesOverdue,
                    totalRecords: totalRecordsOverdue,
                    currentPage: currentPageOverdue,
                }}
            />

            {/* Main Popup */}
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth="xl"
                {...workflowDialogShellProps(isWorkflowMobile)}
                className={workflowDialogClassName('main-dialog dde-workflow-dialog', isWorkflowMobile)}
                PaperProps={{ className: 'dde-workflow-dialog-paper' }}
            >
                <DialogTitle className="dialog-title" >
                    <div className="dde-dialog-header">
                        <Typography className="applicationTitleText">Due Date Extension  -
                            <span style={{ color: 'white' }}>
                                {dialogRowData.applicationProgressId === 0 && ` Application Received`}
                                {dialogRowData.applicationProgressId === 1 && ' Action Taken'}
                                {dialogRowData.applicationProgressId === -1 && ' Action Taken'}
                            </span>
                        </Typography>
                        <button type="button" className="closeIcon" onClick={handleClose} aria-label="Close dialog">
                            <CloseIcon id="clearPopup" sx={{ color: 'white' }} />
                        </button>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText className="dialog-content">
                        <Grid container spacing={1} className='headercontainer'>
                            <Grid item lg={12} className='status-bar'>
                                <StepProgressBar
                                    array={DDStatusBarArray}
                                    applicationProgressId={getDueDateExtensionStepIndex(dialogRowData)}
                                    objection={getDueDateExtensionStepObjection(dialogRowData)}
                                    submittedStepComplete={toProgressId(dialogRowData?.applicationProgressId) === 0}
                                    openDetailsPopUp={openDetailsPopUp}
                                    pageName='Due Date Extension'
                                />
                            </Grid>
                            <Grid item xs={12} className='application-details'>
                                <p className='dde-section-label'>Application Details</p>
                                <div className="dde-details-grid">
                                    <div className='first-row-item'>
                                        <p className='prop-title'>Application Id.</p>
                                        <p className='prop-detail'>{dialogRowData.applicationId}</p>
                                    </div>
                                    <div className='first-row-item'>
                                        <p className='prop-title'>Reference No.</p>
                                        <p className='prop-detail'>{dialogRowData.refNo ? dialogRowData.refNo : "-"}</p>
                                    </div>
                                    <div className='first-row-item'>
                                        <p className='prop-title'>Customer ID</p>
                                        <p className='prop-detail'>{dialogRowData.customerId ? dialogRowData.customerId : '-'}</p>
                                    </div>
                                    <div className='first-row-item'>
                                        <p className='prop-title'>Bill Month</p>
                                        <p className='prop-detail'>{dialogRowData.billMonth ? formatMonthYear(dialogRowData.billMonth) : '-'}</p>
                                    </div>
                                    <div className='first-row-item'>
                                        <p className='prop-title'>Bill Amount</p>
                                        <p className='prop-detail'>{dialogRowData.currentBillAmount ? dialogRowData.currentBillAmount : '-'}</p>
                                    </div>
                                    <div className='first-row-item'>
                                        <p className='prop-title'>Connection Type</p>
                                        <p className='prop-detail'>{dialogRowData.connectionType ? dialogRowData.connectionType : '-'}</p>
                                    </div>
                                    <div className='first-row-item'>
                                        <p className='prop-title'>Tariff</p>
                                        <p className='prop-detail'>{dialogRowData.tariffCode ? dialogRowData.tariffCode : '-'}</p>
                                    </div>
                                    <div className='first-row-item'>
                                        <p className='prop-title'>Subdivision</p>
                                        <p className='prop-detail'>{subdivisionName(dialogRowData.subDivisionCode, subDivisions)}</p>
                                    </div>
                                    <div className='first-row-item'>
                                        <p className='prop-title'>Applicant Name</p>
                                        <p className='prop-detail'>{dialogRowData.name ? dialogRowData.name : '-'}</p>
                                    </div>
                                    <div className='first-row-item'>
                                        <p className='prop-title'>Applicant Phone</p>
                                        <p className='prop-detail'>{dialogRowData.applicantPhone ? dialogRowData.applicantPhone : '-'}</p>
                                    </div>
                                    <div className='first-row-item dde-details-grid__cnic'>
                                        <p className='prop-title'>Applicant CNIC</p>
                                        <p className='prop-detail'>{dialogRowData.cnic ? dialogRowData.cnic : '-'}</p>
                                    </div>
                                    <div className='first-row-item dde-details-grid__email'>
                                        <p className='prop-title'>Applicant Email</p>
                                        <p className='prop-detail'>{dialogRowData.applicantEmail ? dialogRowData.applicantEmail : "-"}</p>
                                    </div>
                                    <div className='first-row-item dde-details-grid__address'>
                                        <p className='prop-title'>Address</p>
                                        <p className='prop-detail'>{dialogRowData.address ? dialogRowData.address : '-'}</p>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item className='processing-summary'>
                                <p className='title'>Activity Log</p>
                                {
                                    <ProcessingSummaryTableBilling data={tableDataProcessingSummary} columns={tableColumnsProcessingSummary} openDetailsPopUp={openDetailsPopUp} />
                                }
                            </Grid>
                            <Grid item className="action-form">
                                <div className='fields'>
                                    {
                                        dialogRowData.applicationProgressId === 0 ?

                                            <>
                                                <h3 className='step-title'>Application Received from {dialogRowData.cfcName ? dialogRowData.cfcName : dialogRowData.submittedThrough ? dialogRowData.submittedThrough : " "}</h3>
                                                <Grid container className='field-survey-container'>
                                                    {
                                                        error &&
                                                        <Error
                                                            error={error}
                                                            onClose={() => errorCloses()}
                                                            backgroundColor="#FFC0CB"
                                                            textColor="#bb0303"
                                                            iconColor="#bb0303"
                                                        />
                                                    }
                                                    <Grid container className="dde-extension-fields-grid">
                                                        <Grid item xs={12}>
                                                            <Typography className='label'>
                                                                Current Due Date
                                                            </Typography>
                                                            <TextField
                                                                value={dialogRowData.dueDate ? convertDate(dialogRowData.dueDate) : '-'}
                                                                fullWidth
                                                                size="small"
                                                                variant="outlined"
                                                                disabled
                                                                InputProps={{
                                                                    style: { height: "36px", backgroundColor: '#eef0f4' },
                                                                }}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12}>
                                                            <Typography className='label'>
                                                                Requested Due Date
                                                            </Typography>
                                                            <TextField
                                                                value={dialogRowData.appliedExtentionOfDueDate ? convertDate(dialogRowData.appliedExtentionOfDueDate) : '-'}
                                                                fullWidth
                                                                size="small"
                                                                variant="outlined"
                                                                disabled
                                                                InputProps={{
                                                                    style: { height: "36px", backgroundColor: '#eef0f4' },
                                                                }}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12}>
                                                            <Typography className='label'>
                                                                No. of Days to Extend
                                                            </Typography>
                                                            <Select
                                                                value={dueDateApprovalFormik.values.iv_approved_no_of_days}
                                                                onChange={dueDateApprovalFormik.handleChange}
                                                                name="iv_approved_no_of_days"
                                                                displayEmpty
                                                                className="fieldBatch"
                                                                fullWidth
                                                                size="small"
                                                            >
                                                                <MenuItem value="" disabled>
                                                                    <em>Select Days</em>
                                                                </MenuItem>

                                                                {(() => {
                                                                    let maxDays = 0;

                                                                    if (
                                                                        CheckPermissions(
                                                                            permissions,
                                                                            "Billing and Collection",
                                                                            "Due Date Extension",
                                                                            "Workflow Permissions",
                                                                            "3 Days"
                                                                        )
                                                                    ) {
                                                                        maxDays = 3;
                                                                    } else if (
                                                                        CheckPermissions(
                                                                            permissions,
                                                                            "Billing and Collection",
                                                                            "Due Date Extension",
                                                                            "Workflow Permissions",
                                                                            "5 Days"
                                                                        )
                                                                    ) {
                                                                        maxDays = 5;
                                                                    } else if (
                                                                        CheckPermissions(
                                                                            permissions,
                                                                            "Billing and Collection",
                                                                            "Due Date Extension",
                                                                            "Workflow Permissions",
                                                                            "8 Days"
                                                                        )
                                                                    ) {
                                                                        maxDays = 8;
                                                                    } else if (
                                                                        CheckPermissions(
                                                                            permissions,
                                                                            "Billing and Collection",
                                                                            "Due Date Extension",
                                                                            "Workflow Permissions",
                                                                            "10 Days"
                                                                        )
                                                                    ) {
                                                                        maxDays = 10;
                                                                    }

                                                                    return Array.from({ length: maxDays }, (_, i) => (
                                                                        <MenuItem key={i + 1} value={i + 1}>
                                                                            {i + 1}
                                                                        </MenuItem>
                                                                    ));
                                                                })()}
                                                            </Select>

                                                            {dueDateApprovalFormik.touched.iv_approved_no_of_days &&
                                                                dueDateApprovalFormik.errors.iv_approved_no_of_days && (
                                                                    <Typography
                                                                        variant="caption"
                                                                        color="error"
                                                                        sx={{ mt: 0.5, display: "block" }}
                                                                    >
                                                                        {dueDateApprovalFormik.errors.iv_approved_no_of_days}
                                                                    </Typography>
                                                                )}
                                                        </Grid>

                                                        <Grid item xs={12}>
                                                            <Typography className='label'>
                                                                Ext. Due Date
                                                            </Typography>
                                                            <TextField
                                                                value={dueDateApprovalFormik.values.iv_approved_due_date ? formatDateToShortMonth(dueDateApprovalFormik.values.iv_approved_due_date) : '-'}
                                                                fullWidth
                                                                size="small"
                                                                variant="outlined"
                                                                disabled
                                                                InputProps={{
                                                                    style: { height: "36px", backgroundColor: '#eef0f4' },
                                                                }}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12}>
                                                            <Typography className='label'>
                                                                Ext. Due Date Day
                                                            </Typography>
                                                            <TextField
                                                                value={
                                                                    dueDateApprovalFormik.values.iv_approved_due_date
                                                                        ? getDayName(dueDateApprovalFormik.values.iv_approved_due_date)
                                                                        : "-"
                                                                }
                                                                fullWidth
                                                                size="small"
                                                                variant="outlined"
                                                                disabled
                                                                InputProps={{
                                                                    style: { height: "36px", backgroundColor: "#eef0f4" },
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Grid>

                                                </Grid>
                                            </>
                                            :
                                            dialogRowData.applicationProgressId === 1 ?
                                                <>
                                                    <div className='step-title step-title--with-action'>
                                                        <h4 className="dde-received-flow">
                                                            Due Date Extended
                                                            <img src={RightArrow} alt='forward to' className="dde-flow-arrow" />
                                                            <span className="dde-flow-pill">
                                                                {dialogRowData.referedToCFC
                                                                    ? dialogRowData.referedToCFC
                                                                    : dialogRowData.cfcName && dialogRowData.cfcName !== "PITC"
                                                                        ? dialogRowData.cfcName
                                                                        : dialogRowData.submittedThrough || '-'}
                                                            </span>
                                                        </h4>
                                                        <Button variant="outlined" onClick={() => { downloadBill(dialogRowData.refNo) }} className="dde-bill-btn">
                                                            <DescriptionIcon sx={{ color: '#006ad1' }} /> Bill
                                                        </Button>
                                                    </div>
                                                    <Grid container className='field-survey-container'>
                                                        <Grid container spacing={1.5} className="dde-extension-fields-grid">
                                                                <Grid item xs={12}>
                                                                    <Typography className='label'>
                                                                        Current Due Date
                                                                    </Typography>
                                                                    <TextField
                                                                        value={dialogRowData.dueDate ? convertDate(dialogRowData.dueDate) : '-'}
                                                                        fullWidth
                                                                        size="small"
                                                                        variant="outlined"
                                                                        disabled
                                                                        InputProps={{
                                                                            style: { height: "36px", backgroundColor: '#eef0f4' },
                                                                        }}
                                                                    />
                                                                </Grid>

                                                                <Grid item xs={12}>
                                                                    <Typography className='label'>
                                                                        Requested Due Date
                                                                    </Typography>
                                                                    <TextField
                                                                        value={dialogRowData.appliedExtentionOfDueDate ? convertDate(dialogRowData.appliedExtentionOfDueDate) : '-'}
                                                                        fullWidth
                                                                        size="small"
                                                                        variant="outlined"
                                                                        disabled
                                                                        InputProps={{
                                                                            style: { height: "36px", backgroundColor: '#eef0f4' },
                                                                        }}
                                                                    />
                                                                </Grid>

                                                                <Grid item xs={12}>
                                                                    <Typography className='label'>
                                                                        No. of Days to Extend
                                                                    </Typography>

                                                                    <Select
                                                                        value={dueDateApprovalFormik.values.iv_approved_no_of_days}
                                                                        onChange={dueDateApprovalFormik.handleChange}
                                                                        name="iv_approved_no_of_days"
                                                                        displayEmpty
                                                                        fullWidth
                                                                        size="small"
                                                                        disabled
                                                                        sx={{
                                                                            '&.Mui-disabled': {
                                                                                backgroundColor: '#eef0f4 !important',
                                                                                borderRadius: '6px',
                                                                            },
                                                                            '& .MuiSelect-select': {
                                                                                backgroundColor: '#eef0f4 !important',
                                                                            },
                                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                                borderColor: '#ccc',
                                                                            },
                                                                            height: '36px',
                                                                        }}
                                                                    >
                                                                        <MenuItem value="" disabled>
                                                                            <em>Select Days</em>
                                                                        </MenuItem>

                                                                        {(() => {
                                                                            let maxDays = 0;

                                                                            if (
                                                                                CheckPermissions(
                                                                                    permissions,
                                                                                    "Billing and Collection",
                                                                                    "Due Date Extension",
                                                                                    "Workflow Permissions",
                                                                                    "3 Days"
                                                                                )
                                                                            ) {
                                                                                maxDays = 3;
                                                                            } else if (
                                                                                CheckPermissions(
                                                                                    permissions,
                                                                                    "Billing and Collection",
                                                                                    "Due Date Extension",
                                                                                    "Workflow Permissions",
                                                                                    "5 Days"
                                                                                )
                                                                            ) {
                                                                                maxDays = 5;
                                                                            } else if (
                                                                                CheckPermissions(
                                                                                    permissions,
                                                                                    "Billing and Collection",
                                                                                    "Due Date Extension",
                                                                                    "Workflow Permissions",
                                                                                    "8 Days"
                                                                                )
                                                                            ) {
                                                                                maxDays = 8;
                                                                            } else if (
                                                                                CheckPermissions(
                                                                                    permissions,
                                                                                    "Billing and Collection",
                                                                                    "Due Date Extension",
                                                                                    "Workflow Permissions",
                                                                                    "10 Days"
                                                                                )
                                                                            ) {
                                                                                maxDays = 10;
                                                                            }

                                                                            return Array.from({ length: maxDays }, (_, i) => (
                                                                                <MenuItem key={i + 1} value={i + 1}>
                                                                                    {i + 1}
                                                                                </MenuItem>
                                                                            ));
                                                                        })()}
                                                                    </Select>

                                                                    {dueDateApprovalFormik.touched.iv_approved_no_of_days &&
                                                                        dueDateApprovalFormik.errors.iv_approved_no_of_days && (
                                                                            <Typography
                                                                                variant="caption"
                                                                                color="error"
                                                                                sx={{ mt: 0.5, display: "block" }}
                                                                            >
                                                                                {dueDateApprovalFormik.errors.iv_approved_no_of_days}
                                                                            </Typography>
                                                                        )}
                                                                </Grid>

                                                                <Grid item xs={12}>
                                                                    <Typography className='label'>
                                                                        Ext. Due Date
                                                                    </Typography>
                                                                    <TextField
                                                                        value={dialogRowData.approvedExtendedDueDate ? convertDate(dialogRowData.approvedExtendedDueDate) : '-'}
                                                                        fullWidth
                                                                        size="small"
                                                                        variant="outlined"
                                                                        disabled
                                                                        InputProps={{
                                                                            style: { height: "36px", backgroundColor: '#eef0f4' },
                                                                        }}
                                                                    />
                                                                </Grid>

                                                                <Grid item xs={12}>
                                                                    <Typography className='label'>
                                                                        Ext. Due Date Day
                                                                    </Typography>
                                                                    <TextField
                                                                        value={
                                                                            dialogRowData.approvedExtendedDueDate
                                                                                ? getDayName(dialogRowData.approvedExtendedDueDate)
                                                                                : "-"
                                                                        }
                                                                        fullWidth
                                                                        size="small"
                                                                        variant="outlined"
                                                                        disabled
                                                                        InputProps={{
                                                                            style: { height: "36px", backgroundColor: "#eef0f4" },
                                                                        }}
                                                                    />
                                                                </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </>
                                                :
                                                dialogRowData.applicationProgressId === -1 ?
                                                    <>
                                                        <h3 className='step-title'>Request Declined</h3>
                                                        <div className="description-box description-box--error">
                                                            <p className="group-description">
                                                                <InfoIcon className="icon" /> Application rejected
                                                            </p>
                                                        </div>
                                                    </> :
                                                    null
                                    }
                                    {!isReleventToUser && (
                                        <div className="description-box description-box--error">
                                            <p className="group-description">
                                                <InfoIcon className="icon" />
                                                Application doesn&apos;t belong to your office.
                                            </p>
                                        </div>
                                    )}
                                </div>
                                {/* <div className="actions">
                                    {dialogRowData.applicationProgressId === 0 && (

                                        <>
                                            {
                                                isReleventToUser ?
                                                    <>
                                                        {!isExtensionDateExpired(dialogRowData.appliedExtentionOfDueDate) &&
                                                            canApprove(parseInt(dialogRowData.currentBillAmount.replace(/,/g, ''))) && (
                                                                <button
                                                                    className="view-button"
                                                                    onClick={dueDateApprovalFormik.handleSubmit}
                                                                >
                                                                    Approve
                                                                </button>
                                                            )}

                                                        <button
                                                            className="reject-button"
                                                            style={{ float: "right", marginRight: "10px" }}
                                                            onClick={handleOpen}
                                                        >
                                                            Reject
                                                        </button>
                                                    </>
                                                    :
                                                    <div style={{ margin: 'auto', padding: '10px', backgroundColor: '#C46500', color: 'white', borderRadius: '5px', textAlign: 'center' }}>
                                                        <p style={{ fontSize: '20px' }}>
                                                            Application doesn't belongs to your office.
                                                        </p>
                                                    </div>
                                            }

                                        </>
                                    )}
                                </div> */}
                                <div className="actions">
                                    {!isSameBillMonth(dBillMonthDate, tableMonthDate) &&
                                        toProgressId(dialogRowData.applicationProgressId) !== 1 &&
                                        toProgressId(dialogRowData.applicationProgressId) !== -1 && (
                                        <div className="description-box description-box--error">
                                            <p className="group-description">
                                                <InfoIcon className="icon" />
                                                Your due date extension can&apos;t be processed for this billing month — please apply again with the correct month.
                                            </p>
                                        </div>
                                    )}
                                    {isReleventToUser == true  ? (
                                        dialogRowData.applicationProgressId === 0 &&
                                            <>
                                                {isSameBillMonth(dBillMonthDate, tableMonthDate) &&
                                                    !isExtensionDateExpired(dialogRowData.appliedExtentionOfDueDate) &&
                                                    canApprove(parseInt(dialogRowData.currentBillAmount.replace(/,/g, ''))) && (
                                                        <button
                                                            className="view-button"
                                                            onClick={dueDateApprovalFormik.handleSubmit}
                                                        >
                                                            Approve
                                                        </button>
                                                    )}

                                                <button
                                                    className="reject-button"
                                                    onClick={handleOpen}
                                                >
                                                    Reject
                                                </button>
                                            </>
                                      
                                    ) : null}
                                </div>
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
            </Dialog >

            <Dialog
                open={applicationSubittedPopUp}
                onClose={() => setApplicationSubmittedPopUp(false)}
                fullWidth
                maxWidth="md"
                className="wf-submitted-dialog"
                PaperProps={{ className: 'wf-submitted-dialog__paper' }}
            >
                <DialogTitle className="dialog-title">
                    <div className="wf-dialog-header">
                        <Typography className="wf-dialog-title-text">Application Submitted</Typography>
                        <button
                            type="button"
                            className="wf-dialog-close"
                            onClick={() => setApplicationSubmittedPopUp(false)}
                            aria-label="Close dialog"
                        >
                            <CloseIcon id="clearPopup" />
                        </button>
                    </div>
                </DialogTitle>
                <DialogContent className="wf-submitted-dialog__content">
                    <div className="wf-application-details-body">
                        <p className="wf-section-label">Application Details</p>
                        <div className="wf-details-grid">
                            <div className="wf-detail-item wf-detail-item--span2">
                                <p className="prop-title">Application Id</p>
                                <p className="prop-detail">{dialogRowData.applicationId || '-'}</p>
                            </div>
                            <div className="wf-detail-item wf-detail-item--span2">
                                <p className="prop-title">Applicant Name</p>
                                <p className="prop-detail">{dialogRowData.name || '-'}</p>
                            </div>
                            <div className="wf-detail-item wf-detail-item--span2">
                                <p className="prop-title">Received From</p>
                                <p className="prop-detail">{dialogRowData.cfcName || '-'}</p>
                            </div>
                            <div className="wf-detail-item">
                                <p className="prop-title">Applied Date</p>
                                <p className="prop-detail">{convertDate(dialogRowData.creationDate) || '-'}</p>
                            </div>
                            <div className="wf-detail-item">
                                <p className="prop-title">Subdivision</p>
                                <p className="prop-detail">
                                    {subdivisionName(dialogRowData.subDivisionCode, subDivisions) || '-'}
                                </p>
                            </div>
                            <div className="wf-detail-item">
                                <p className="prop-title">Applied Load</p>
                                <p className="prop-detail">{dialogRowData.appliedLoad || '-'}</p>
                            </div>
                            <div className="wf-detail-item">
                                <p className="prop-title">Connection Type</p>
                                <p className="prop-detail">{dialogRowData.connectionType || '-'}</p>
                            </div>
                            <div className="wf-detail-item wf-detail-item--span2">
                                <p className="prop-title">Sub. Through</p>
                                <p className="prop-detail">{dialogRowData.submittedThrough || '-'}</p>
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions className="wf-submitted-dialog__footer">
                    <p className="wf-submitted-dialog__footer-text">
                        Application Submitted by:{' '}
                        {String(dialogRowData.createdBy).length === 13 && /^\d+$/.test(dialogRowData.createdBy)
                            ? dialogRowData.name
                            : dialogRowData.createdBy}{' '}
                        on: {convertDatewithTime(dialogRowData.creationDate)}
                    </p>
                </DialogActions>
            </Dialog>

            <Dialog
                open={Boolean(activeResultDialog)}
                onClose={handleCloseResultPopup}
                className={`dde-result-dialog${resultPopup === 'reject' ? ' dde-result-dialog--reject' : ''}`}
                fullWidth
                maxWidth="sm"
                PaperProps={{ className: 'dde-result-dialog__paper' }}
            >
                {activeResultDialog ? (
                    <>
                        <DialogTitle className="dde-result-dialog__title">
                            <Box className="dde-result-dialog__icon-wrap">
                                <activeResultDialog.Icon className={activeResultDialog.iconClassName} />
                            </Box>
                            <Typography variant="h6" className="dde-result-dialog__heading">
                                {activeResultDialog.title}
                            </Typography>
                        </DialogTitle>
                        <DialogContent className="dde-result-dialog__content">
                            <DialogContentText>
                                <p className="dde-result-dialog__message">{activeResultDialog.message}</p>
                                {activeResultDialog.showBill ? (
                                    <Box className="dde-result-dialog__actions">
                                        <Button
                                            type="button"
                                            variant="outlined"
                                            className="dde-result-dialog__bill-btn"
                                            onClick={() => downloadBill(dialogRowData.refNo)}
                                        >
                                            <DescriptionIcon className="dde-result-dialog__bill-icon" />
                                            Bill
                                        </Button>
                                    </Box>
                                ) : null}
                            </DialogContentText>
                        </DialogContent>
                    </>
                ) : null}
            </Dialog>


            {/* Remarks Dialog */}
            <Dialog
                open={openCancelModal}
                className="dde-remarks-dialog"
                onClose={handleCloseRemarks}
                maxWidth="sm"
                fullWidth
                PaperProps={{ className: 'dde-remarks-dialog__paper' }}
            >
                <DialogTitle className="dde-remarks-dialog__title">
                    <div className="dde-remarks-dialog__header">
                        <Typography className="dde-remarks-dialog__heading">Remarks</Typography>
                        <button
                            type="button"
                            className="dde-remarks-dialog__close"
                            onClick={handleCloseRemarks}
                            aria-label="Close remarks dialog"
                        >
                            <CloseIcon id="clearPopup" />
                        </button>
                    </div>
                </DialogTitle>
                <DialogContent className="dde-remarks-dialog__content">
                    <TextField
                        autoFocus
                        id="iv_remarks"
                        placeholder="Enter remarks for rejection (minimum 10 characters)"
                        type="text"
                        fullWidth
                        variant="outlined"
                        onChange={remarksFormik.handleChange}
                        onBlur={remarksFormik.handleBlur}
                        name="iv_remarks"
                        value={remarksFormik.values.iv_remarks}
                        multiline
                        minRows={5}
                        maxRows={8}
                        className="dde-remarks-dialog__textarea"
                        error={Boolean(remarksFormik.touched.iv_remarks && remarksFormik.errors.iv_remarks)}
                    />
                    {remarksFormik.touched.iv_remarks && remarksFormik.errors.iv_remarks ? (
                        <p className="dde-remarks-dialog__error">{remarksFormik.errors.iv_remarks}</p>
                    ) : null}
                    {error ? (
                        <Error
                            error={error}
                            onClose={() => errorCloses()}
                            backgroundColor="#FFC0CB"
                            textColor="#bb0303"
                            iconColor="#bb0303"
                        />
                    ) : null}
                </DialogContent>
                <DialogActions className="dde-remarks-dialog__actions">
                    <Button
                        type="button"
                        onClick={remarksFormik.handleSubmit}
                        className="dde-remarks-dialog__btn dde-remarks-dialog__btn--confirm"
                    >
                        Confirm
                    </Button>
                    <Button
                        type="button"
                        onClick={handleCloseRemarks}
                        className="dde-remarks-dialog__btn dde-remarks-dialog__btn--cancel"
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <AppLoader />
            </Backdrop >

        </>
    )
})

export default DueDateExtensionTable;
